import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import ContentBlock from "./ContentBlock/ContentBlock";
import MiddleBlock from "./MiddleBlock/MiddleBlock";
import BlogCard from "../../Views/BlogView/BlogList/BlogCard";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import styles from "./Edu.module.css";
import { toast } from "react-toastify";

import MainBlockContent from "../Edu/Content/MainBlockContent.json";
import IntroContent from "./Content/IntroContent.json";
import MiddleBlockContent from "./Content/MiddleBlockContent.json";
import AboutContent from "./Content/AboutContent.json";
import MissionContent from "./Content/MissionContent.json";
import ProductContent from "./Content/ProductContent.json";

const Edu = () => {
  const { accessToken } = useAuth();
  const [blogs, setBlogs] = useState([]);
  const [reels, setReels] = useState([]);

  // Fetch Blogs
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/edu/blogs`,
          {
            headers: {
              // Authorization: `Bearer ${accessToken}`, // @see: no authorization as this is a public url
            },
          }
        );
        if (response.status === 200 && response.data.success) {
          setBlogs(response.data.blogs.slice(0, 6)); // Fetch first 6 blogs
        } else {
          console.error("Failed to fetch blogs");
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  // Fetch Reels
  // @TODO: should not fetch reels from dash route
  // Fetch Reels
  useEffect(() => {
    const fetchReels = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/edu/pro-sm?typeSMId=2`, // Instagram reels
          {
            headers: {
              // Authorization: accessToken,
            },
          }
        );
        if (response.status === 200 && response.data.success) {
          setReels(response.data.smLinks);
          // console.log("Fetched Reels:", response.data.smLinks);
        } else {
          const errorMsg = response.data.message || "Failed to fetch reels.";
          toast.error(errorMsg);
        }
      } catch (error) {
        console.error("Error fetching reels:", error);
      }
    };

    fetchReels();
  }, [accessToken]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const getEmbedUrl = (url) => {
    if (url) {
      return `https://www.instagram.com/p/${url
        .split("/")
        .slice(-2, -1)}/embed/`;
    }
    return null;
  };

  return (
    <>
      <Navbar />
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>Education</h1>
      </div>
      <MiddleBlock
        title={MainBlockContent.title}
        content={MainBlockContent.text}
        button={MainBlockContent.button}
        navLink={"/Courses"}
      />
      <ContentBlock
        direction="right"
        title={IntroContent.title}
        content={IntroContent.text}
        button={IntroContent.button}
        icon="developer.svg"
        id="intro"
      />

      {/* Blog Carousel Section */}
      <section className={styles.blogSection}>
        <h2>Latest Blogs</h2>
        <Carousel
          responsive={responsive}
          swipeable
          draggable
          showDots={false}
          ssr={true}
          infinite={true}
          autoPlay={false}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          containerClass={styles.carouselContainer}
          itemClass={styles.carouselItemPadding}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          // dotListClass="custom-dot-list-style"
        >
          {blogs.map((blog) => (
            <div key={blog.id} className={styles.carouselItem}>
              <BlogCard blog={blog} onClick={() => {}} />
            </div>
          ))}
        </Carousel>
      </section>

      {/* Reels Carousel Section */}
      <section className={styles.reelsSection}>
        <h2>Instagram Reels</h2>
        <Carousel
          responsive={responsive}
          swipeable
          draggable
          showDots={false}
          ssr={true}
          infinite={true}
          autoPlay={false}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          // containerClass={styles.carouselContainer}
          // itemClass={styles.carouselItemPadding}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          // dotListClass="custom-dot-list-style"
        >
          {reels.map((reel, index) => (
            <div key={index} className={styles.carouselItem}>
              <div className={styles.reelBox}>
                <iframe
                  className={styles.video}
                  src={getEmbedUrl(reel.url)}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <div className={styles.reelInfo}>
                  <p>
                    <a
                      href={reel.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View on Instagram
                    </a>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </section>

      <Footer />
    </>
  );
};

export default Edu;
